import { useCallback, useState } from "react";

// Pairs with <NotificationModal>: const { notification, notify, dismiss } = useNotification();
const useNotification = () => {
  const [notification, setNotification] = useState(null);

  const notify = useCallback((variant, title, message) => {
    setNotification({ variant, title, message });
  }, []);

  const dismiss = useCallback(() => setNotification(null), []);

  return { notification, notify, dismiss };
};

export default useNotification;
